module.exports = __webpack_public_path__ + "fonts/Baloo2-Regular.20f6d004.ttf";